//
//
//
//
//
//

import index from './index';
export default {
  name: 'Expenditure',
  components: {
    index: index
  }
};